:host {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 15px;
}

.label {
  display: flex;
  .h4 {
    font: $xp-ref-font-headline-headline05;
    color: $xp-ref-color-text-default-dark;
  }
}

.steps {
  display: flex;
  padding-bottom: $xp-ref-spacing-2;
  width: auto;
  height: 100%;
  gap: 8px;

  @include mobile {
    flex-direction: column;
  }

  @include tablet {
    flex-direction: row;
  }

  @include desktop {
    flex-direction: row;
  }
}
